import { faUserFriends } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Room, RoomEvent, setLogLevel, VideoPresets } from "livekit-client";
import { DisplayContext, LiveKitRoom } from "@livekit/react-components";
import { DisplayOptions } from "@livekit/react-components";
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export const RoomPage = () => {
  const [numParticipants, setNumParticipants] = useState(0);

  const [displayOptions] = useState<DisplayOptions>({
    stageLayout: "grid",
    showStats: false,
  });

  const navigate = useNavigate();
  const query = new URLSearchParams(useLocation().search);
  const url = query.get("url");
  const token = query.get("token");
  const recorder = query.get("recorder");

  if (!url || !token) {
    return <div className="errorBox">URL and token are required</div>;
  }

  const onLeave = () => {
    navigate("/");
  };

  const updateParticipantSize = (room: Room) => {
    setNumParticipants(room.participants.size + 1);
  };

  const onParticipantDisconnected = (room: Room) => {
    updateParticipantSize(room);

    if (recorder && parseInt(recorder, 10) === 1 && room.participants.size === 0) {
      console.log("END_RECORDING");
    }
  };

  return (
    <DisplayContext.Provider value={displayOptions}>
      <div className="room-wrapper">
        {/* TOP BAR */}
        <header className="room-topbar">
          <div className="room-title">Shatel Voice Center</div>

          <div className="room-right">
            <div className="participant-counter">
              <FontAwesomeIcon icon={faUserFriends} />
              <span>{numParticipants}</span>
            </div>

            <button className="leave-button" onClick={onLeave}>
             خروج
            </button>
          </div>
        </header>

        {/* LIVEKIT STAGE */}
        <main className="room-stage">
          <LiveKitRoom
            url={url}
            token={token}
            onConnected={(room) => {
              setLogLevel("debug");
              onConnected(room, query);
              room.on(RoomEvent.ParticipantConnected, () => updateParticipantSize(room));
              room.on(RoomEvent.ParticipantDisconnected, () => onParticipantDisconnected(room));
              updateParticipantSize(room);
            }}
            roomOptions={{
              adaptiveStream: isSet(query, "adaptiveStream"),
              dynacast: isSet(query, "dynacast"),
              publishDefaults: {
                simulcast: isSet(query, "simulcast"),
              },
              videoCaptureDefaults: {
                resolution: VideoPresets.h720.resolution,
              },
            }}
            onLeave={onLeave}
          />
        </main>
      </div>
    </DisplayContext.Provider>
  );
};

async function onConnected(room: Room, query: URLSearchParams) {
  (window as any).currentRoom = room;

  if (isSet(query, "audioEnabled")) {
    const audioDeviceId = query.get("audioDeviceId");
    if (audioDeviceId && room.options.audioCaptureDefaults) {
      room.options.audioCaptureDefaults.deviceId = audioDeviceId;
    }
    await room.localParticipant.setMicrophoneEnabled(true);
  }

  if (isSet(query, "videoEnabled")) {
    const videoDeviceId = query.get("videoDeviceId");
    if (videoDeviceId && room.options.videoCaptureDefaults) {
      room.options.videoCaptureDefaults.deviceId = videoDeviceId;
    }
    await room.localParticipant.setCameraEnabled(true);
  }
}

function isSet(query: URLSearchParams, key: string): boolean {
  return query.get(key) === "1" || query.get(key) === "true";
}
